import { render, staticRenderFns } from "./ChangeAdministrationNotifications.vue?vue&type=template&id=0bc18535"
import script from "./ChangeAdministrationNotifications.vue?vue&type=script&lang=js"
export * from "./ChangeAdministrationNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports